<template>
  <div>
    <router-view></router-view>
    <van-tabbar v-model="active" active-color="#fff">
      <van-tabbar-item class="color" to="/home">
        <span>云养狗</span>
        <img slot="icon" :src="active==0?imgurl:imgurl1" />
      </van-tabbar-item>
      <van-tabbar-item class="color" to="/situation">
        <span>服务中心</span>
        <img slot="icon" :src="active==1?imgurl2:imgurl3" />
      </van-tabbar-item>
      <van-tabbar-item class="color" to="/my">
        <span>我的</span>
        <img slot="icon" :src="active==2?imgurl4:imgurl5" />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import store from "@/vuex/store";
import { mapState } from "vuex";
export default {
  store,
  data() {
    return {
      imgurl: require("@/assets/images/tabbar/homeSel.png"),
      imgurl1: require("@/assets/images/tabbar/home.png"),
      imgurl2: require("@/assets/images/tabbar/serviceSel.png"),
      imgurl3: require("@/assets/images/tabbar/service.png"),
      imgurl4: require("@/assets/images/tabbar/mySel.png"),
      imgurl5: require("@/assets/images/tabbar/my.png"),
      active: 0,
      cartCount: ""
    };
  },
  computed: {
    ...mapState({
      selectGoods: state => state.selectGoods //绑定store.selectGoods到组件，之后可用this.selectGoods获取
    })
  },
  created() {
    if (this.$route.name == "situation") {
      this.active = 1;
    } else if (this.$route.name == "home") {
      this.active = 0;
    } else if (this.$route.name == "my") {
      this.active = 2;
    }
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped>
.van-hairline--top-bottom::after {
  border: none;
}
.van-tabbar-item__text {
  color: #222;
}
.color {
  color:#222;
  background: #FFAA24;
}
</style>


// WEBPACK FOOTER //
// src/pages/Main.vue